import axios from 'axios'
import { appSettings } from 'settings/app-settings'

export const baseURL = appSettings.api.REACT_APP_BASE_URL

export const instance = axios.create({
  baseURL,
  withCredentials: true,
})
